<div class="lcl-shipment-container" [ngClass]="{ 'xl-container-padding': (headerType$ | async) === headerTypes.LCLShipment }">
  <div class="lcl-shipment-wrapper">
    <lcl-shipment-payment-card
      *ngIf="isPayment || isPaymentPending"
      [pendingBills]="pendingBills"
      [shipment]="shipment"
      [isCouponAvailable]="isCouponAvailable"
      (applyCoupon)="applyCoupon.emit($event)"
    ></lcl-shipment-payment-card>
    <div class="container">
      <tabset>
        <tab [heading]="'LABELS.SUMMARY' | translate">
          <div class="scrollable-wrapper">
            <div class="fix-scroll">
              <div class="lcl-shipment-card">
                <section class="lcl-shipment-card-body">
                  <mobile-lcl-card *ngIf="isLaptop" [info]="shipment" [isShipment]="true"></mobile-lcl-card>
                  <app-lcl-shipment-tracking-state [currentState]="shipment.trackingState"></app-lcl-shipment-tracking-state>

                  <ng-container *ngIf="!isInsuranceLoading && isDestinationUSA">
                    <app-marine-insurance-quote-pricing-card
                      *ngIf="
                        !isInsuranceAvailable &&
                        !paidOrSentPaymentStates.includes(currentInsurance?.paymentState) &&
                        shipment.state !== enumShipmentState.CANCELED
                      "
                      [marineInsurance]="currentInsurance"
                      [pendingBills]="pendingMarineInsuranceBills"
                      [isWithMarginTop]="true"
                      [parent]="shipment"
                      (edit)="openMarineInsuranceQuoteForm.emit(true)"
                    ></app-marine-insurance-quote-pricing-card>

                    <app-marine-insurance-quote-updated-pricing-card
                      *ngIf="
                        !isInsuranceAvailable &&
                        paidOrSentPaymentStates.includes(currentInsurance?.paymentState) &&
                        currentInsurance?.pendingPaymentAction === enumMarineInsurancePendingPaymentAction.ADDITIONAL_PAYMENT &&
                        pendingMarineInsuranceBills?.items?.length
                      "
                      [marineInsurance]="currentInsurance"
                      [pendingBills]="pendingMarineInsuranceBills"
                    ></app-marine-insurance-quote-updated-pricing-card>
                  </ng-container>

                  <div class="shipment-steps-description" [innerHTML]="stepDescription"></div>

                  <app-lcl-card [cardTitle]="'LABELS.SHIPMENT_DETAILS' | translate">
                    <ng-container body>
                      <lcl-shipment-details [shipment]="shipment"></lcl-shipment-details>
                    </ng-container>
                  </app-lcl-card>

                  <app-lcl-packages-view
                    [packages]="shipment.packages"
                    [isEditablePackages]="isEditablePackages"
                    [isShipmentLayout]="true"
                    [packagesStatus]="shipment.packagesConfirmationState"
                    (removePackage)="onRemovePackage($event)"
                    (savePackages)="onSavePackages($event)"
                  ></app-lcl-packages-view>

                  <div class="row">
                    <div
                      class="col-12"
                      [ngClass]="{
                        'col-xl-6': shipment.trackingState === TRACKING_STATES.AT_ORIGIN_WAREHOUSE,
                        'col-xl-4': shipment.trackingState > TRACKING_STATES.AT_ORIGIN_WAREHOUSE
                      }"
                    >
                      <app-lcl-card cardTitle="LABELS.ORIGIN_WAREHOUSE" isEqual="true">
                        <ng-container body>
                          <app-lcl-origin-warehouse [shipment]="shipment"></app-lcl-origin-warehouse>
                        </ng-container>
                      </app-lcl-card>
                    </div>

                    <div
                      class="col-12"
                      [ngClass]="{
                        'col-xl-6': shipment.trackingState === TRACKING_STATES.AT_ORIGIN_WAREHOUSE,
                        'col-xl-8': shipment.trackingState > TRACKING_STATES.AT_ORIGIN_WAREHOUSE
                      }"
                      *ngIf="shipment.trackingState >= TRACKING_STATES.AT_ORIGIN_WAREHOUSE"
                    >
                      <app-lcl-card cardTitle="LABELS.DESTINATION_WAREHOUSE" isEqual="true">
                        <ng-container body>
                          <app-lcl-destination-warehouse [shipment]="shipment"></app-lcl-destination-warehouse>
                        </ng-container>
                      </app-lcl-card>
                    </div>
                  </div>

                  <app-lcl-shipment-contacts
                    [shipment]="shipment"
                    [isEditable]="isEditableContacts"
                    (updateEntity)="updateEntity.emit($event)"
                    (deleteEntity)="removeEntity.emit($event)"
                  ></app-lcl-shipment-contacts>

                  <lcl-shipment-product-box
                    *ngIf="isShowProductBoxes"
                    [shipment]="shipment"
                    [linkedISF]="linkedISF"
                    [isIsf]="true"
                    (fileISF)="fileISF.emit($event)"
                  ></lcl-shipment-product-box>
                  <lcl-shipment-product-box
                    *ngIf="isShowProductBoxes"
                    [shipment]="shipment"
                    [linkedES]="linkedES"
                    [isIsf]="false"
                    (fileES)="fileES.emit($event)"
                  ></lcl-shipment-product-box>

                  <ng-container *ngIf="!isInsuranceLoading && isDestinationUSA">
                    <app-marine-insurance-quote-view-card
                      *ngIf="
                        !isInsuranceAvailable &&
                        (paidOrSentPaymentStates.includes(currentInsurance?.paymentState) ||
                          currentInsurance?.pendingPaymentAction === enumMarineInsurancePendingPaymentAction.ADDITIONAL_PAYMENT)
                      "
                      [marineInsurance]="currentInsurance"
                      [documents]="currentInsuranceDocuments"
                      [isShowUpdated]="
                        !!currentInsurance?.updatedInsuredValue?.insuredAmount &&
                        (!pendingMarineInsuranceBills?.items?.length || currentInsurance?.partiallyRefundConfirmed)
                      "
                      [isPendingAdminApproval]="
                        (!pendingMarineInsuranceBills?.items?.length &&
                          currentInsurance?.pendingPaymentAction === enumMarineInsurancePendingPaymentAction.ADDITIONAL_PAYMENT) ||
                        (pendingMarineInsuranceBills?.items?.length && currentInsurance?.partiallyRefundConfirmed)
                      "
                      (edit)="openMarineInsuranceQuoteForm.emit(true)"
                    ></app-marine-insurance-quote-view-card>
                  </ng-container>
                </section>
              </div>
            </div>
          </div>
        </tab>

        <tab [heading]="'MENU.DOCUMENTS' | translate">
          <div class="scrollable-wrapper">
            <div class="fix-scroll">
              <div class="lcl-shipment-card">
                <section class="lcl-shipment-card-body">
                  <app-lcl-shipment-documents
                    [company]="company"
                    [shipment]="shipment"
                    [linkedES]="linkedES"
                    [isCanRemove]="isEditableDocs"
                    (downloadAllFiles)="downloadAllFiles.emit($event)"
                  ></app-lcl-shipment-documents>
                </section>
              </div>
            </div>
          </div>
        </tab>

        <tab [heading]="'LABELS.SHIPMENT_CHARGES' | translate">
          <div class="scrollable-wrapper">
            <div class="fix-scroll">
              <div class="lcl-shipment-card">
                <section class="lcl-shipment-card-body">
                  <app-lcl-shipment-user-charges
                    [company]="company"
                    [shipment]="shipment"
                    [payedBills]="payedBills"
                    [pendingBills]="pendingBills"
                  ></app-lcl-shipment-user-charges>
                </section>
              </div>
            </div>
          </div>
        </tab>
      </tabset>
    </div>
  </div>
</div>
